// import the react components
import React from "react";

// the title functional based component
const Title = ({icon, text}) => {
    return (
        <div className="flex items-center gap-2.5 mb-4">
            <span className="w-9 h-9 rounded-lg bg-primary text-white flex items-center justify-center text-base flex-shrink-0">{icon}</span>
            <h1 className="text-lg font-medium text-gray-900 dark:text-gray-100 capitalize">{text}</h1>
        </div>
    );
};
export default Title;